const avatar = {
    diameter: {
        SMALL: '2.5rem',
        MEDIUM: '3.5rem',
        LARGE: '5rem',
    },
    innerDiameter: {
        SMALL: '2.25rem',
        MEDIUM: '3.25rem',
        LARGE: '4.5rem',
    },
    fontSize: {
        SMALL: '0.8125rem',
        MEDIUM: '1.25rem',
        LARGE: '1.75rem',
    },
};
export default avatar;
//# sourceMappingURL=avatar.js.map